import { render, staticRenderFns } from "./WorkOnDocument.vue?vue&type=template&id=2ea4ee68&scoped=true&"
import script from "./WorkOnDocument.ts?vue&type=script&lang=ts&"
export * from "./WorkOnDocument.ts?vue&type=script&lang=ts&"
import style0 from "./WorkOnDocument.vue?vue&type=style&index=0&id=2ea4ee68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea4ee68",
  null
  
)

export default component.exports
import {QSpinnerGears,QBtn,QPopupProxy,QPopupEdit,QInput,QLinearProgress,QTooltip,QSpinner,QMenu,QCheckbox,QDialog,QCard,QCardSection,QField} from 'quasar'
component.options.components = Object.assign({QSpinnerGears,QBtn,QPopupProxy,QPopupEdit,QInput,QLinearProgress,QTooltip,QSpinner,QMenu,QCheckbox,QDialog,QCard,QCardSection,QField}, component.options.components || {})
